import React from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css'; // Bootstrap 5 icons
import imgAvatar1 from '../Images/dubai1.jpg';
import imgAvatar2 from '../Images/malaysia.jpg';
import '../CSS/ChooseUs.css';

const ChooseUs = () => {
    return (
        <div className="choose-us-page">
            {/* Why Choose Us Section */}
            <section className="section why-choose text-center">
                <div className="container">
                    <h2 className="section-title">Why Choose Us?</h2>
                    <div className="row align-items-center">
                        {/* Circular Images */}
                        <div className="col-md-4 text-center">
                            <div className="image-container">
                                <img src={imgAvatar1} alt="Travel Experience" className="img-fluid circle-img mb-3" />
                                <img src={imgAvatar2} alt="Travel Adventure" className="img-fluid circle-img" />
                            </div>
                        </div>

                        {/* Benefits Section */}
                        <div className="col-md-8">
                            <div className="row">
                                {/* First Row */}
                                <div className="col-md-4 col-sm-6 mb-4">
                                    <div className="benefit-box">
                                        <i className="bi bi-person-check-fill benefit-icon"></i>
                                        <h5>Personalized Plans</h5>
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-6 mb-4">
                                    <div className="benefit-box">
                                        <i className="bi bi-tag-fill benefit-icon"></i>
                                        <h5>Best Price</h5>
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-6 mb-4">
                                    <div className="benefit-box">
                                        <i className="bi bi-headset benefit-icon"></i>
                                        <h5>24/7 Support</h5>
                                    </div>
                                </div>

                                {/* Second Row */}
                                <div className="col-md-4 col-sm-6 mb-4">
                                    <div className="benefit-box">
                                        <i className="bi bi-shield-lock-fill benefit-icon"></i>
                                        <h5>Safe Travel</h5>
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-6 mb-4">
                                    <div className="benefit-box">
                                        <i className="bi bi-star-fill benefit-icon"></i>
                                        <h5>Top Destinations</h5>
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-6 mb-4">
                                    <div className="benefit-box">
                                        <i className="bi bi-people-fill benefit-icon"></i>
                                        <h5>Happy Travelers</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Statistics Section */}
            <section className="section statistics text-center">
                <div className="container">
                    <div className="row">
                        <div className="col-md-3 stat-box">
                            <h1>7000+</h1>
                            <p>Happy Travelers</p>
                        </div>
                        <div className="col-md-3 stat-box">
                            <h1>500+</h1>
                            <p>Successful Tours</p>
                        </div>
                        <div className="col-md-3 stat-box">
                            <h1>12+</h1>
                            <p>Years of Experience</p>
                        </div>
                        <div className="col-md-3 stat-box">
                            <h1>24/7</h1>
                            <p>Customer Support</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ChooseUs;
